import { Image, Label, Panel, PanelProps, PanelStyles, TreeNode } from "@mcleod/components";
import { LogManager } from "@mcleod/core";
import { RowUserMenuFavorite } from "../models/ModelUserMenuFavorite";
import { MainMenu } from "./MainMenu";
import { MainMenuTree } from "./MainMenuTree";
import { MenuFavorites } from "./MenuFavorites";
import { MenuTreeNodeLeaf } from "./MenuTreeNodeLeaf";

const log = LogManager.getLogger("common/menu/PanelFavorites");

export class PanelFavorites extends Panel {
    treeFavoritesMenu: MainMenuTree;
    imageFavorite: Image;
    private mainMenu: MainMenu;

    constructor(mainMenu: MainMenu, props?: Partial<PanelProps>) {
        super({...props});
        this.mainMenu = mainMenu;
        MenuFavorites.addFavoritesChangedCallback(this.populateFavoriteItemsTree);

        this.imageFavorite = new Image({
            id: "imageFavorite",
            stroke: "default",
            themeKey: "menu.favoriteImage"
        })

        const panelTitle = new Panel({
            fillRow: true,
            borderBottomWidth: 1,
            borderBottomColor: "strokeSecondary",
            paddingRight: 8,
            paddingLeft: 8,
            components: [
                new Label({
                    paddingLeft: 0,
                    paddingRight: 0,
                    id: "labelFavorites",
                    text: "Favorites",
                    fontSize: "small",
                    fontBold: true,
                    color: "component.palette.menu.mainColor",
                    fillRow: true,
                    rowBreak: false,
                }),
                this.imageFavorite
            ]
        });
        this.add(panelTitle);

        this.treeFavoritesMenu = new MainMenuTree(this.mainMenu, {
            maxHeight: 136,
            paddingLeft: 0
        });
        this.populateFavoriteItemsTree();
    }

    private populateFavoriteItemsTree = () => {
        const menuNodes: MenuTreeNodeLeaf[] = MenuFavorites.getFavorites()
            .filter(fav => fav.data != null)
            .map(fav => this.createFavoriteMenuItem(fav));

        log.debug("favorite menu items", menuNodes);
        this.populateUnfilteredOneLevelMenuTree(menuNodes);
    }

    private createFavoriteMenuItem(favorite: RowUserMenuFavorite) {
        const menuItem = new MenuTreeNodeLeaf(this.mainMenu, { menuItem: favorite.data });
        menuItem.setLabelProps({marginLeft: 4});
        return menuItem;
    }

    private populateUnfilteredOneLevelMenuTree(nodes: MenuTreeNodeLeaf[]) {
        const root = new TreeNode({ tree: this.treeFavoritesMenu });
        for (const node of nodes) {
            root.addChild(node);
        }
        this.treeFavoritesMenu.getRootNode().padding = 0;
        this.treeFavoritesMenu.getRootNode().setChildren(root.getChildren());
        if (nodes.length === 0) {
            if (this.contains(this.treeFavoritesMenu))
                this.remove(this.treeFavoritesMenu);
        } else {
            if (!this.contains(this.treeFavoritesMenu))
                this.add(this.treeFavoritesMenu);
        }
    }

    selectFirstFavorite() {
        this.mainMenu.selectFirstFavorite();
    }
}
